const ROWS = Array.from({ length: 9 }, (_, index) => index)

/**
 * Placeholder rows for the left-hand conversation list, shown while the chats
 * are loading so the panel never appears blank or half-populated.
 */
const RecentChatsSkeleton = ({ label = 'Loading chats...' }: { label?: string }) => (
  <div className="chat-skeleton chat-skeleton--list" role="status" aria-busy="true">
    <span className="visually-hidden">{label}</span>
    {ROWS.map((row) => (
      <div key={row} className="chat-skeleton__row" aria-hidden="true">
        <span className="chat-skeleton__avatar" />
        <span className="chat-skeleton__lines">
          <span className="chat-skeleton__line chat-skeleton__line--name" />
          <span className="chat-skeleton__line chat-skeleton__line--preview" />
        </span>
        <span className="chat-skeleton__time" />
      </div>
    ))}
  </div>
)

export default RecentChatsSkeleton
